import {
    IonCol,
    IonItem,
    IonLabel,
    IonList,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { Event, EventJudge } from "../../../models";
import { getEventJudgesByEventId } from "../../../utilities/eventJudge/EventJudge";
import { getHorseShowByEventId } from "../../../utilities/horseShow/HorseShow";
import moment from "moment";
import Spinner from "../../Spinners/Spinner";

interface _Props {
    event: Event
}

const EventDisplayJudges: React.FC<_Props> = ({event}) => {

    const [eventJudges, setEventJudges] = useState<(EventJudge | null)[] | null | undefined>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function getHorseShowJudges(eventId: string) {
            setIsLoading(true);
            const queryResult = await getEventJudgesByEventId(eventId);
            if (queryResult.isSuccess) {
                const judges: EventJudge[] = queryResult.result;

                // Sort them in the order in which they were created (first created -> last created)
                const sorted = judges.sort(function(a: EventJudge, b: EventJudge): number {
                    const aMoment: any = a.createdAt ? moment(a.createdAt) : null;
                    const bMoment: any = b.createdAt ? moment(b.createdAt) : null;
                    const aVal: string = aMoment ? aMoment.format("YYYYMMDDHHmmss") : "0";
                    const bVal: string = bMoment ? bMoment.format("YYYYMMDDHHmmss") : "0";
                    return aVal.localeCompare(bVal);
                });

                setEventJudges(sorted);
            }
            setIsLoading(false);
        }
        if (event) getHorseShowJudges(event.id);
    }, [event]);

    return (
        <>
            {isLoading ?
                    <IonRow className="ion-justify-content-center">
                        <IonCol className="ion-text-center">
                            <Spinner />
                        </IonCol>
                    </IonRow>
                :
                <>
                    {eventJudges && eventJudges.length ?
                        <IonRow>
                            <IonCol>
                                <IonList className="bg-white">
                                    {eventJudges.map((judge, index) => (
                                        <IonItem key={index}>
                                            <IonLabel><h3 className="ion-text-wrap text-darker">{judge && judge.name}</h3></IonLabel>
                                        </IonItem>
                                    ))}
                                </IonList>
                            </IonCol>
                        </IonRow>
                        :
                        <>
                            <IonRow>
                                <IonCol>
                                    <IonItem>
                                        <IonLabel><h3 className="ion-text-wrap text-darker">No judges listed.</h3></IonLabel>
                                    </IonItem>
                                </IonCol>
                            </IonRow>
                        </>
                    }
                </>
            }
        </>
    );
};

export default EventDisplayJudges;